<template>
    <div class="flex relative my-auto container mx-auto">

      <div class="subsection-big-circle flex flex-col bg-black rounded-full mx-auto">
        <h1 class="text-white mx-auto pt-20 text-2xl font-bold">HOW TO MAKE MONEY</h1>
        <div class="flex flex-col mx-auto mt-8 w-full">
          <div class="flex justify-between px-8">
            <div class="mini-circles flex flex-col bg-yellow-500 rounded-full cursor-pointer" @click="showPdf('pdfUrlOne')">
              <div class="mt-12 inline mx-auto">
                <h4 class="font-bold text-xl border-b-2">AD REVENUE</h4>

                <p class="mt-4 font-bold">POTENTIALS <br><span class="text-sm">(PDF)</span></p>
              </div>
            </div>
            <div class="mini-circles flex flex-col bg-yellow-500 rounded-full cursor-pointer" @click="showPdf('pdfUrlTwo')">
              <div class="mt-12 inline mx-auto">
                <h4 class="font-bold text-xl border-b-2">AD REVENUE</h4>

                <p class="mt-4 font-bold">ESTIMATED <br><span class="text-sm">(Video)</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <NextArrow next="sub-process-two"/>

    </div>
</template>

<script>
import NextArrow from "@/components/deepinfo/subnavigation/NextArrow.vue";

export default {
  name: "ProcessSubOne",
  props:{
    pdfUrlOne:{
      required: true,
      type: String,
    },
    pdfUrlTwo:{
      required: true,
      type: String,
    },
  },
  components:{
    NextArrow
  },
  methods:{
    showPdf(prop){
      window.open(this[prop]);
    }
  }
}
</script>

<style lang="css" scoped>
  .mini-circles{
    width: 11rem;
    height: 11rem;
    background-color: #f6faa0;
    color: #fa4141;
  }
</style>
